import { HttpClientModule } from "@angular/common/http";
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import {
  BpopSecurityFrontendLibModule,
  MainService,
} from "@avaldigitallabs/bpop-security-frontend-lib";

import { from } from "rxjs";
import { concatMap } from "rxjs/operators";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AppDesignModule } from "./design/app-design.module";

import { environment } from "../environments/environment";

import { ToggleService } from "./services/local/toggle.service";
import { TealiumUtagService } from "./tealium/utag.service";

function initializeAppFactory(
  provider: ToggleService,
  mainService: MainService,
) {
  return () => {
    return from(mainService.initializeSecurityKeys()).pipe(
      concatMap(() => from(provider.resolve())),
    );
  };
}

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BpopSecurityFrontendLibModule.forRoot({
      environment: environment.security,
    }),
    AppDesignModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [ToggleService, MainService],
      multi: true,
    },
    TealiumUtagService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
